import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ClickOutsideDirective } from './click-outside.directive';
import { HighlightPipe } from './highlight.pipe';
import { MatBadgeIconDirective } from './mat-badge-icon.directive';
import { MatSelectOpened } from './mat-select-opened.directive';
import { MycurrencyPipe } from './mycurrency.pipe';
import { RemoveImageTitleAttrDirective } from './remove-title-attr.directive';
import { ReplacePipe } from './replace.pipe';
import { SafeHtmlPipe } from './safe-html.pipe';
import { ShowTooltipIfHeightTruncatedDirective } from './show-tooltip-if-height-truncated.directive';
import { ShowTooltipIfTruncatedDirective } from './show-tooltip-if-truncated.directive';
import { TruncatePipe } from './truncate.pipe';

@NgModule({
  exports: [
    RemoveImageTitleAttrDirective,
    ReplacePipe,
    ClickOutsideDirective,
    MatBadgeIconDirective,
    MycurrencyPipe,
    HighlightPipe,
    ShowTooltipIfTruncatedDirective,
    ShowTooltipIfHeightTruncatedDirective,
    MatSelectOpened,
    TruncatePipe,
    SafeHtmlPipe,
  ],
  imports: [
    CommonModule,
    RemoveImageTitleAttrDirective,
    ReplacePipe,
    ClickOutsideDirective,
    MatBadgeIconDirective,
    MycurrencyPipe,
    HighlightPipe,
    ShowTooltipIfTruncatedDirective,
    ShowTooltipIfHeightTruncatedDirective,
    MatSelectOpened,
    TruncatePipe,
    SafeHtmlPipe,
  ],
})
export class SharedModule {}
